// extracted by mini-css-extract-plugin
export var box = "_1t-1";
export var checkboxRow = "_1t-8";
export var checked = "_1t-2";
export var descriptionSpacer = "_1t-a";
export var disabled = "_1t-3";
export var icon = "_1t-6";
export var input = "_1t-0";
export var labelSpacer = "_1t-9";
export var medium = "_1t-5";
export var small = "_1t-4";
export var text = "_1t-7";